import React from 'react';
import { BodyLoading, BodyLoadingSpin } from "./styled";
import SpinIconLoading from "../assets/spin-icon.svg";

const LoadingSpin = () => {
  return (
    <BodyLoading>
      <BodyLoadingSpin>
        <img src={SpinIconLoading} alt={SpinIconLoading}/>
      </BodyLoadingSpin>
    </BodyLoading>
  )
};

export default LoadingSpin;
